import React from 'react'
import './ComplainLottie.css'
import Lottie from 'react-lottie';
import * as animationData from './Complain.json';
const ComplainLottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <div className='complain-lottey '>
                <Lottie className=" lotties"
                    options={defaultOptions}
                />
            </div>
        </>
    )
}

export default ComplainLottie